import { useEffect } from 'react'


// Do something on click outside element
export const useOnClickOutside = (ref, handler) => {
  useEffect(
    () => {
      const listener = (e) => {
        // Do nothing if clicking ref's element or descendent elements
        if (!ref.current || ref.current.contains(e.target)) return
        handler(e)
      }

      document.addEventListener('mousedown', listener)
      document.addEventListener('touchstart', listener)

      return () => {
        document.removeEventListener('mousedown', listener)
        document.removeEventListener('touchstart', listener)
      }
    },

    // Wrap handler in useCallback before passing it into this hook to avoid unneccessary rerenders
    [ ref, handler ]
  )
}

export default useOnClickOutside
